import React, { useState, useRef, useEffect, useReducer } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Card, Link, Typography, Stack, Button, InputAdornment, TextField, ListItemIcon, Container } from '@mui/material';
import Grid from '@mui/material/Grid'
import { useForm, Controller } from "react-hook-form";
import IconButton from '@mui/material/IconButton';

// Redux Api Call
import { useGetCategoryQuery, useGetSubCategoryQuery } from '../../../redux/services/common/Common';
import { useGetFoodUpdateMutation } from '../../../redux/services/seller/sellerInfo';
import { useGetvariantsApiMutation, useGetvariantsDeleteApiMutation } from '../../../redux/services/variant/variant';


// Icons
import FastfoodOutlinedIcon from '@mui/icons-material/FastfoodOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import CloseIcon from '@mui/icons-material/Close';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
// alert
import { showSuccess, showError } from '../../../utils/toast';
import VariantTable from '../../variant/variantTable';
import { apiUrl } from '../../../utils/api';
import { useNavigate, useParams } from 'react-router-dom';

// Modal
import { AlertDialog } from '../../../utils/dealog/diloag';
import UpdateVariant from '../../variant/updateVariant';
import AddVariant from '../../variant/addVariant';






const DataLogo = ({ name, path }) => {
    const url = `${apiUrl.foodImg}${path}`;
    console.log('EditeImg', url);
    return (
        <img alt={name} src={url} style={{ height: "100%", width: "100%", borderRadius: '8px' }} />
    )
}

export const FoodMenuEdite = (props) => {
    const { food, setFood, setLoadMenu, reloadData, foodDetails } = props;
    const [foodCategory, setFoodCategory] = useState('')
    // Redux Api Calling
    console.log("foodData", food)
    const { data: categoryes } = useGetCategoryQuery()
    const { data: subcategory } = useGetSubCategoryQuery(foodCategory)
    const [getEditeFood, EditeFood] = useGetFoodUpdateMutation()

    const { register, handleSubmit, setValue, watch, reset, control, formState: { errors } } = useForm();

    // Id sellerInfo
    const { id } = useParams();
    const handleFoodCategory = (e) => {
        setFoodCategory(e.target.value);
    };

    useEffect(() => {
        setValue('name', food?.name);
        setValue('type', food?.type);
        setValue('description', food?.description);
        setValue('category', food?.category?.id);
        setValue('subcategory', foodCategory);
        if (food) {
            setFoodCategory(food?.category?.parent?.id || '');
        }

    }, [food])

    // useEffect(() => {
    //     setValue('name', foodDetails?.name);
    //     setValue('type', foodDetails?.type);
    //     setValue('description', foodDetails?.description);
    //     setValue('category', foodDetails?.category?.id);
    //     setValue('subcategory', foodCategory);
    //     if (foodDetails) {
    //         setFoodCategory(foodDetails?.category?.parent?.id || '');
    //     }

    // }, [foodDetails])


    // Update FoodMenu
    const onUpdateFoodMenu = async (data) => {

        const formData = new FormData();
        formData.append('id', food?.id);
        formData.append('seller', id);
        formData.append('name', data.name);
        formData.append('description', data.description);
        formData.append('category', data.category);
        formData.append('type', data.type);
        formData.append('thumb', data.thumb);
        formData.append('photo1', data.photo_1);
        formData.append('photo2', data.photo_2);
        console.log("thumb", data.thumb, data.photo_2, data.photo_1)
        console.log("Food Edite", formData)


        try {

            const EaditeFood = await getEditeFood(formData)
            setFood(EaditeFood.data);
            console.log("editeFood", EaditeFood.data)

            setLoadMenu(true)
            setFood(null)
            reloadData()
            reset()

        } catch (error) {
            console.log("error", error)
            showError(error || " Food Menu Updated  !")

        }
    }

    useEffect(() => {
        if (EditeFood.isSuccess) {
            showSuccess('Food Updated Success',)
        }
        if (EditeFood.isError) {
            showError('Some Thing Wrong', EditeFood.error.data.msg)
        }

    }, [EditeFood])




    return (
        <>
            <Dialog
                open={food != null}
                onClose={() => { setFood(null) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={() => { setFood(null) }}
                    aria-label="close"
                    sx={{ alignSelf: 'end' }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>
                    <Typography variant='h4'>{food?.name}</Typography>
                </DialogTitle>
                <DialogContent sx={{ width: "100%" }}>
                    <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center" }}>
                        <Typography variant='h6'>{food?.category?.name}</Typography>
                    </DialogContentText>
                    <br />
                    <br />
                    <form id="edit-form" onSubmit={handleSubmit(onUpdateFoodMenu)}>

                        <Grid container spacing={1} mb={2}>
                            <Grid item xs={12} sm={6} md={4} >
                                <Controller
                                    name="thumb"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    <DataLogo path={food?.thumbnail} />
                                                )}
                                            </div>
                                            <label htmlFor="thumb" className="footer">
                                                <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M15.331 6H8.5v20h15V14.154h-8.169z" /><path d="M18.153 6h-.009v5.342H23.5v-.002z" /></g></svg>
                                                <p> Update Img</p>
                                                <input
                                                    // className='shop_Phot0'
                                                    id='thumb'
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                    style={{
                                                        display: "none",
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} >

                                <Controller
                                    name="photo_1"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    <DataLogo path={food?.image_1} />
                                                )}
                                            </div>
                                            <label htmlFor="photo1" className="footer">
                                                <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M15.331 6H8.5v20h15V14.154h-8.169z" /><path d="M18.153 6h-.009v5.342H23.5v-.002z" /></g></svg>
                                                <p> Update Img</p>

                                                <input
                                                    // style={{ display: "none" }}
                                                    id="photo1"
                                                    type="file"
                                                    // {...register('photo_1')}
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                    style={{
                                                        display: "none",
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Controller
                                    name="photo_2"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    <DataLogo path={food?.image_2} />
                                                )}
                                            </div>
                                            <label htmlFor="photo2" className="footer">
                                                <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M15.331 6H8.5v20h15V14.154h-8.169z" /><path d="M18.153 6h-.009v5.342H23.5v-.002z" /></g></svg>
                                                <p> Update Img</p>

                                                <input
                                                    id="photo2"
                                                    type="file"
                                                    // {...register('photo_2')}
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                    style={{
                                                        display: "none",
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    )}
                                />

                            </Grid>
                        </Grid>
                        <Grid container spacing={1} mt={5} >
                            <Grid item xs={12} sm={6} md={6} mb={5}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                    <FastfoodOutlinedIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    <TextField fullWidth id="input-with-sx" label="Name" variant="standard" {...register("name", { required: 'Enter Food name' })} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} mb={5}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                    <MenuBookOutlinedIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    <TextField fullWidth id="input-with-sx" label="Description" variant="standard" {...register("description", { required: 'Enter Food Description' })} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} mb={5}>
                                <FormControl variant="standard" fullWidth>
                                    <InputLabel id="area-label">Select Category</InputLabel>
                                    <Select
                                        labelId="area-label"
                                        label="Select Category"
                                        {...register("subcategory", { required: 'Enter category' })}
                                        value={foodCategory}
                                        onChange={handleFoodCategory}
                                        defaultValue=""
                                    >
                                        {categoryes && categoryes?.data?.map((opetion) => <MenuItem key={opetion?.id} value={opetion?.id}>{opetion?.name}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl variant="standard" fullWidth>
                                    <InputLabel id="area-label">Select subCategory</InputLabel>
                                    <Select
                                        labelId="area-label"
                                        label="Select sub Category"
                                        {...register("subcategory", { required: 'Enter category' })}
                                        value={watch("category") || (food?.category?.id || '')}
                                        onChange={(e) => setValue("category", e.target.value)}
                                        defaultValue=""
                                    >
                                        {subcategory && subcategory?.data?.map((opetion) => <MenuItem key={opetion?.id} value={opetion?.id}>{opetion?.name}</MenuItem>)}

                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField
                                    name='type'
                                    fullWidth
                                    select
                                    label="Type"
                                    {...register("type", { required: 'select type ' })}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    variant="standard"
                                >
                                    <option value={'V'}>Veg</option>
                                    <option value={'N'}>NonVeg</option>
                                    <option value={'E'}>Egg</option>
                                </TextField>
                            </Grid>
                        </Grid>

                        <DialogActions>
                            <Button type="submit" form="edit-form"  >
                                Update
                            </Button>
                            <Button onClick={() => { setFood(null) }}  >
                                Cancel
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog>
        </>
    );

}


